export default function DatePrint({date}) {
    const dateForPrint = new Date(date);
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

    return `${dateForPrint.toLocaleDateString('no-NB', options)}`;
}